import { useState } from "react";
import { Btn, Modal, Field, Inp, Txta, FormRow, Stage, Chips, Selo, ExpandTable, Detalhe } from "../components/primitives";

function PromptModal({ initial, onClose, onSave }) {
  const [f, setF] = useState(initial || { title: "", category: "Geral", content: "", tags: [] });
  const up = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const [saving, setSaving] = useState(false);
  async function save() { setSaving(true); await onSave(f); setSaving(false); }

  return (
    <Modal title={initial ? "Editar prompt" : "Novo prompt"} onClose={onClose} width={580}>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <FormRow>
          <Field label="Título" half><Inp value={f.title} onChange={(e) => up("title", e.target.value)} /></Field>
          <Field label="Categoria" half>
            <Inp value={f.category || ""} onChange={(e) => up("category", e.target.value)} placeholder="AC, AT, Copy..." />
          </Field>
        </FormRow>
        <Field label="Conteúdo do prompt">
          <Txta rows={10} value={f.content} onChange={(e) => up("content", e.target.value)} placeholder="Escreva o prompt aqui..." />
        </Field>
        <Btn variant="accent" full onClick={save} disabled={saving}>{saving ? "Salvando..." : "Salvar"}</Btn>
      </div>
    </Modal>
  );
}

export function PromptsView({ prompts, onNew, onUpdate }) {
  const [search,   setSearch]   = useState("");
  const [category, setCategory] = useState("Todos");
  const [selected, setSelected] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [copied,   setCopied]   = useState(null);

  const categories = ["Todos", ...new Set(prompts.map((p) => p.category).filter(Boolean))];

  const visible = prompts.filter((p) => {
    const q = search.toLowerCase();
    return (
      (category === "Todos" || p.category === category) &&
      (!q || p.title?.toLowerCase().includes(q) || p.content?.toLowerCase().includes(q))
    );
  });

  function copy(text, id) {
    navigator.clipboard.writeText(text);
    setCopied(id);
    setTimeout(() => setCopied(null), 1800);
  }

  return (
    <div className="view">
      <Stage
        path="prompts"
        title="Base de"
        hl="conhecimento"
        lead={<>{prompts.length} prompts cadastrados</>}
        actions={<Btn sm variant="primary" onClick={() => setShowForm(true)}>+ Novo prompt</Btn>}
      />

      <div style={{ display: "flex", gap: 10, marginBottom: 18, flexWrap: "wrap", alignItems: "center" }}>
        <Inp value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar prompts..." style={{ maxWidth: 300 }} />
        <Chips
          label="Categoria"
          items={categories.map((cat) => ({ id: cat, label: cat, count: cat === "Todos" ? prompts.length : prompts.filter((p) => p.category === cat).length }))}
          active={category}
          onChange={setCategory}
        />
      </div>

      <ExpandTable
        rows={visible}
        minWidth={560}
        empty="Nenhum prompt encontrado."
        columns={[
          { key: "title", label: "Prompt", render: (p) => <span className="name">{p.title}</span> },
          { key: "category", label: "Categoria", render: (p) => p.category ? <Selo tone="info" dot={false}>{p.category}</Selo> : <span className="sub">—</span> },
          { key: "copiar", label: "", align: "right", render: (p) => (
            <span onClick={(e) => e.stopPropagation()}>
              <Btn sm variant={copied === p.id ? "success" : "ghost"} onClick={() => copy(p.content, p.id)}>
                {copied === p.id ? "✓ Copiado" : "Copiar"}
              </Btn>
            </span>
          ) },
        ]}
        detail={(p) => (
          <div className="detail-grid">
            <Detalhe label="Conteúdo" pre>{p.content}</Detalhe>
            <div className="detail-actions">
              <Btn sm variant="secondary" onClick={() => setSelected(p)}>Editar</Btn>
            </div>
          </div>
        )}
      />

      {showForm && (
        <PromptModal onClose={() => setShowForm(false)} onSave={async (data) => { await onNew(data); setShowForm(false); }} />
      )}
      {selected && (
        <PromptModal initial={selected} onClose={() => setSelected(null)}
          onSave={async (data) => { await onUpdate(selected.id, data); setSelected(null); }} />
      )}
    </div>
  );
}
